import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom'

import App from './App.js'
import Login from './pages/auth/Login.js'
import PrivateRoute from './PrivateRoute.js'
import React, { Suspense, lazy } from 'react'
import Export from './pages/export/Export.js'
import Backup from './pages/backup/Backup.js'
import Refresh from './pages/refresh/Refresh.js'
import LoginGigya from './pages/auth/LoginGigya.js'
import TemporaryLogin from './pages/auth/TemporaryLogin.js'
import RegisterGigya from './pages/auth/RegisterGigya.js'

// Lazy: páginas públicas raramente visitadas e online-only (EULA + fluxo de
// senha) saem do bundle inicial. Export/Backup/Refresh/logins permanecem
// eager — precisam funcionar offline/imediato.
const CookiesPolicy = lazy(() => import('./pages/auth/eula/CookiesPolicy'))
const PrivacyPolicy = lazy(() => import('./pages/auth/eula/PrivacyPolicy'))
const UsersLicense = lazy(() => import('./pages/auth/eula/UsersLicense'))
const ForgotPassword = lazy(() => import('./pages/auth/ForgotPassword.js'))
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword.js'))

// react-router-dom v7: <Routes> -> <Routes>, element={<X />} -> element={<X/>},
// `exact` removido (default), <Redirect> -> <Navigate>. Rotas sem `exact` em
// v5 que faziam prefix-match agora precisam de `/*` no final.
export const router = (
  <Router>
    <Suspense fallback={null}>
      <Routes>
        <Route path='/cookies/*' element={<CookiesPolicy />} />
        <Route path='/userslicense/*' element={<UsersLicense />} />
        <Route path='/privacy/*' element={<PrivacyPolicy />} />
        <Route path='/forgot-password/*' element={<ForgotPassword />} />
        <Route path='/reset-password/*' element={<ResetPassword />} />
        <Route path='/export/*' element={<Export />} />
        <Route path='/backup-and-exit/*' element={<Backup />} />
        <Route path='/hard-refresh/*' element={<Refresh />} />

        <Route path='/loginAntigo' element={<Login />} />
        <Route path='/login' element={<LoginGigya />} />
        <Route path='/primeiro-login' element={<TemporaryLogin />} />
        <Route path='/register-gigya' element={<RegisterGigya />} />
        <Route
          path='/*'
          element={<PrivateRoute element={<App />} route='/' />}
        />
      </Routes>
    </Suspense>
  </Router>
)
